export default __webpack_public_path__ + "static/media/petition-mobile.3af3bade.svg";